import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import Gallery from "../../components/Gallery/Gallery";
import FunFactsArchitecture3 from "../../components/FunFacts/FunFactsArchitecture3";

import { HashLink as Link } from 'react-router-hash-link';



import CTAOne from "../../components/CTA/CTAOne";


const paragraph2 = (
  <>
    {`Here's How ${new Date().getFullYear()} Is Adding Up So Far:`}
    <br />
    {`YTD Average Price Comparison of All Property Types`}
  </>
);

const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef(); 
  const rentals = useRef();
  const contact = useRef();

  const scrollToSection = (e, content) => {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
          break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <Loader>
      <HeaderOne  />
      <section className=" mt-minus-50">
        <div className="container mt-minus-50">
      <div className="row mt-minus-50">
        <HeadingSection
       
          classAppend="dark-color"
        > <h2>OUR SERVICES</h2></HeadingSection>
      </div>
      <div id= "versus"></div>
     <h2>CORPORATE RELOCATION</h2><br />

  
<p><h3>RELOCATING TO NEW YORK</h3></p>
<p>Moving to Manhattan, but don't know what kind of apartment you should look for? Should it be a charming prewar, a snazzy new condo, or a cozy brownstone? How about a spectacular loft? And where do you want to live - near work, in a happening area, or in a quiet family neighborhood? And what can you afford?</p>

<p>Don't worry, we're here with the answers.</p>

<br /><br /><div><Link to="/corporate-relocation#versus">COOP vs CONDO</Link> &bull; <Link to="/corporate-relocation#apartmenttypes">APARTMENT TYPES</Link> &bull; <Link to="/corporate-relocation#apartmentstyles">APARTMENT STYLES</Link> &bull; <Link to="/corporate-relocation#neighborhoods">NEIGHBORHOODS</Link></div><br />

<br /><br />
<h2>APARTMENTS: COOP vs CONDO</h2>
<p>There are primarily two kinds of apartments for sale in Manhattan, coop and condos. The vast majority (over 80%) are coops, while the rest are condos. They have different advantages, and you should choose the best one for you.</p>

<h3>I. Coops</h3>

<p>With a cooperative apartment you actually own shares in a corporation which gives you a proprietary lease to the apartment. Your monthly maintenance charge pays all costs to run the building, your real estate taxes, heat, water - everything but electric. Owning a coop can be a little restrictive: you must be interviewed and approved to purchase, any alterations must be approved by the board, as must any sublet and resale. They may or may not take pets. There are usually financing restrictions as well; typically a coop will not let you finance more than 75%.</p>

<p>The plusses are generally a lower price than a condo, and control over building tenancy.</p>

<h3>II. Condos</h3>

<p>A condominium is a fee type of ownership, and you actually own the four walls of the apartment as well as pay your own real estate taxes. Condos are very flexible: you can buy them in any name you want (i.e. corporate ownership, etc.), there is a less intrusive application process and rarely an interview. The only way a condo can reject a sublet or sale is to exercise their right of first refusal by matching the sale or rental price.</p>

<p>Condos in New York also tend to be newer luxury highrises, with fancy finishings such as marble baths, health clubs, and roof gardens. So if you want something fancy and new, condo is the way to go. However they tend to be considerably more expensive than coops (30% or more for equivalent size units.)</p>

<h3>III. Single Family Housing - Townhouses and Brownstones</h3>

<p>Large individual townhouses do exist in Manhattan. They are generally 3-4 stories high and 17-22 feet wide. A typical townhouse is anywhere from 3000-6000 square feet, and will often have a private garden. Some are single family homes, and some have rental apartments in them that can generate income for the owner. Prices start at about $3,000,000 and go upward from there.</p>


<div id= "apartmenttypes"></div>
<br /><br />
<div><Link to="/corporate-relocation#versus">COOP vs CONDO</Link> &bull; <Link to="/corporate-relocation#apartmenttypes">APARTMENT TYPES</Link> &bull; <Link to="/corporate-relocation#apartmentstyles">APARTMENT STYLES</Link> &bull; <Link to="/corporate-relocation#neighborhoods">NEIGHBORHOODS</Link></div><br />
<br /><br />
<h2>APARTMENT TYPES</h2>

<p>There are three basic styles as well as three basic types of apartments here. The three main types are Pre-war, Post-war, and New Construction; the main styles are Highrises, Brownstones, and Lofts.</p>

<h3>I. Prewar</h3>
<p>Prewar apartments are those built before WW II. These are very desirable in Manhattan, because they tend to be built in the prime locations and have lots of charm and detail. Such elegant detail might include high ceilings, replaces, crown moldings, patterned hardwood floors, and thick plaster walls. </p>
  
  <p>Most prewar buildings in prime locations have doormen.</p>

<h3>II. Postwar</h3>

<p>Postwar apartments are those built from 1946-1980. They are typically large highrise buildings with doormen and a superintendent/resident manager. Some have garages, gyms, storage, bike rooms; high floors often have great open city views. Floorplans can range from studios, one bedrooms and two bedrooms and three bedrooms. Typical features are 8' ceilings, parquet hardwood floors, and galley style kitchens.</p>

<h3>III. New Construction</h3>

<p>Thanks to major tax incentives, there was a swell of new construction in Manhattan from 1983-1990 and again from 1996-today.
This new construction is typically a highrise condominium. Though the 1983-1990 units may be slightly smaller than their postwar
counterparts, they tend to offer high-end finishes (marble baths, private washer/dryers), and more building amenities (health clubs, pools, kid's playrooms). Many feature doormen and garages. The newest developments focus primarily on larger, family sized apartments on the Upper East or West Side, while Tribeca, Soho, and Chelsea boast of dramatic new loft buildings with immense apartments by the world's leading architects and designers. Selling prices on these stunning homes can range from $1,500 to over $6,000 per square foot.</p>



<div id= "apartmentstyles"></div>
<br /><br />
<div><Link to="/corporate-relocation#versus">COOP vs CONDO</Link> &bull; <Link to="/corporate-relocation#apartmenttypes">APARTMENT TYPES</Link> &bull; <Link to="/corporate-relocation#apartmentstyles">APARTMENT STYLES</Link> &bull; <Link to="/corporate-relocation#neighborhoods">NEIGHBORHOODS</Link></div><br />
<br /><br />
<h2>APARTMENT STYLES</h2>

<h3>I. Highrise</h3>
<p>These can be either prewar or postwar, and are typically 12-80 stories, with a doorman, laundry facility in the basement, and
sometimes a garage. Other amenities might include a roof garden, bike room, and individual storage bins. Newer buldings may have a
health club.</p>
<p>There are highrise buildings throughout the city, but the vast concentration is from 14th Street to 96th Street on both the east and west side. Larger buildings can be found on the avenues, while slightly smaller buildings would be found on the side streets.</p>

<h3>II. Townhouse/Brownstone Apartments</h3>

<p>A townhouse/brownstone apartment is usually in a small 3-5 story building. Most of these units were originally part of single- family homes, built in the 1800s-1920, that have since been divided into apartments. Many townhouses are loaded with charm and have fireplaces, architectural details, and high ceilings. Ground floor units often feature large private gardens and top floors often have roof decks. Most buildings are too small to have doormen but usually offer an intercom or a virtual security system. Bbuyers who prefer quiet spaces, tree lined streets, gardens, and privacy often love these types of units. Townhouses and Brownstones are located primarily on the side streets of the East and West sides, in Greenwich Village and Chelsea.</p>

<h3>III. Lofts</h3>

<p>Lofts are residential apartments that were often created out of former commercial buildings and warehouses. They offer huge unconventional spaces that can be individually designed. Starting at around 1000 square feet, they can range from 1000 to over 5000 square feet or more. Originally converted for use by artists, more and more buyers have moved into lofts to take advantage of the space and Downtown vibe. Lofts are primarily found in Soho, Tribeca, and Chelsea. Some have doormen, and many have soaring ceilings, large windows and fabulous storage. In the last 20 years, there has seen a proliferation of high-end designer lofts built with all the amenities of a typical residential building, such as garages, gyms, doormen, and children's play rooms.</p>



<div id= "neighborhoods"></div>
<br /><br /><br />
<div><Link to="/corporate-relocation#versus">COOP vs CONDO</Link> &bull; <Link to="/corporate-relocation#apartmenttypes">APARTMENT TYPES</Link> &bull; <Link to="/corporate-relocation#apartmentstyles">APARTMENT STYLES</Link> &bull; <Link to="/corporate-relocation#neighborhoods">NEIGHBORHOODS</Link></div>
<br /><br />
<h2>NEIGHBORHOODS</h2>

<p>There are many different neighborhoods in Manhattan, all with a distinct air and history. One of the best ways to explore a neighborhood is to walk it. The following is a brief description of some of Manhattan's most popular neighborhoods.</p>


<p>
<div class="row">
<div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/UES.jpg")}  alt=""  style={{ height: '410px' }} /></div><div className="col-md-9"><h3>I. The Upper East Side</h3><br />
From 59th Street to 96th Street, bordered by the East River and Fifth Avenue, this is one of Manhattan's most popular residential neighborhoods. Residential amenities abound, including restaurants, shopping, good public schools, and "Museum Mile". Central Park and Carl Schurz Park (East End/ Gracie Mansion) are within a few blocks for most residents. Easy transportation to midtown and Wall Street gcan be accessed by the 4,5, 6 and Q trains and express buses. Fifth and Park Avenues offer some of the most beautiful -- and expensive -- real estate in Manhattan.</div>
</div>
</p>


<p>
<div class="row">
<div className="col-md-9"><h3>II. Midtown</h3><br />
From 23rd Street to 59th Street, bordered primarily by First and Eighth Avenues, this area has more of a mixed commercial flavor, incorporating the Midtown business district. It is an easy walk to work and steps away from Broadway theaters and Carnegie Hall. It is conveniently located to the United Nations, Sutton Place and Beekman Place.</div><div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/MIDTOWN.jpg")}  alt=""  style={{ height: '410px' }} /></div>
</div>
</p>


<p>
<div class="row">
<div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/UWS.jpg")}  alt=""  style={{ height: '410px' }} /></div><div className="col-md-9"><h3>III. The Upper West Side</h3><br />
The Upper West Side is bordered by Central Park and Riverside Park. It is a vibrant and cultural neighborhood with close proximity to Lincoln Center and the Museum of Natural History. The Upper West Side is loaded with restaurants, boutiques and wonderful gourmet stores,  including Zabar's. Transportation is abundant, with 4 major subway lines (1,2,3,and A) and busses are everywhere. </div>
</div>
</p>


<p>
<div class="row">
<div className="col-md-9"><h3>IV. Greenwich Village / Chelsea</h3><br />
Greenwich Village is well known as a hotbed of artistic and cultural thought, this charming area is known for its collection of smaller brownstone buildings and cobblestone streets. Hip stores and quaint restaurants rule. While the area near NYU in central Greenwich Village hums all night long, those seeking quiet charm go west of Seventh Avenue to stroll amidst landmark townhouses on quaint tree-lined streets.
<p>Chelsea is one of the city's hottest areas, due in part to its world class Sports and Film complex at Chelsea Piers, and its many art galleries that line the side streets.</p></div><div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/VILLAGE.jpg")}  alt=""  style={{ height: '410px' }} /></div>
</div>
</p>




<p>
<div class="row">
<div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/SOHO.jpg")}  alt=""  style={{ height: '410px' }} /></div><div className="col-md-9"><h3>V. SOHO / Tribeca</h3><br />
Soho ("South of Houston") and Tribeca ("Triangle Below Canal") are generally industrial areas, but over the last thirty years they have become extremely popular with those seeking oversized loft homes. Originally settled by artists seeking large studios, many of the wonderful old cast iron warehouses and factories have been gut renovated to create some spectacular residences. Some buildings maintain the restriction "artists only", but by and large those restrictions have eased and most anyone can live there. Soho is renowned for its spectacular upscale and trendy shopping, while Tribeca now hosts some of the world's hippest restaurants.</div>
</div>
</p>

<p>
<div class="row">
<div className="col-md-9"><h3>VI. Upper Manhattan</h3><br />
Upper Manhattan begins with Harlem (125th Street) and stretches all the way up to the northern tip of the island, where neighborhoods including Hamilton Heights, Audubon Terrace, Washington Heights, Hudson Heights, and Inwood. Harlem is known for its brownstones and rich history; the Heights and Inwood have become housing destinations for many professionals, artists and academics looking for a little more nature and a little less bustle. Easily accessible by A Train Express and local 1 and 9 subway lines, these cozy neighborhoods feature pockets of real New York history, beauty and nature including the Apollo Theatre, the Cloisters Museum in Fort Tryon Park, and Inwood Hill Park. The predominant architecture of gracious pre-war and Art Deco co-ops make Upper Manhattan the perfect choice for those who want to live large at a more reasonable price.</div><div className="col-md-3">
<img src={require("../../assets/images/neighborhoods/HARLEM.jpg")}  alt=""  style={{ height: '410px' }} /></div>
</div>
</p>

    </div>
    </section>

    <FunFactsArchitecture3
                
                title={new Date().getFullYear()}
                tagline="By The Numbers"
                paragraph1="In 2024 the average asking price in the luxury sector ($4 million and above) was 4%
                higher than 2023. Once again, condos outsold co-ops more than 3-to-1, reflecting an ongoing trend: The
                average luxury buyer wants the freedom of condo ownership, new construction, and a
                robust menu of amenities. Townhouse sales were flat."
                paragraph2={paragraph2}  paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`}  paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
              />


    <Gallery
        title="MORE FEATURED PROPERTIES"
        tagline="Currently ON MARKET"
        classAppend="mt-150"
        ref={sales}
      />

      <ContactArchitecture
        title="CONTACT OLSHAN"
        tagline="Connect to Your New Home"
        classAppend="mt-50"
        ref={contact}
      />

<CTAOne
        tagline="Olshan Luxury Report"
        title="Highly focused. Data Driven."
        textButton="GET THE LATEST LUXURY REPORT"
        linkButton="/market-report"
        bg="color"
      >
        This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
      </CTAOne>
      <FooterOne />
    </Loader>
  );
};



export default Architecture;
